import React, { useRef, useEffect } from "react";
import Highcharts, { color } from "highcharts";
import HighchartsReact from "highcharts-react-official";

const StockLineChart = () => {
  const areaChart = {
    chart: {
      backgroundColor: null,
      height: '320',
      // width: '600'
    },
    title: {
      text: '',
      align: 'left'
    },

    yAxis: {
      title: {
        text: ''
      }
    },

    xAxis: {
      categories: ['JAN','FEB','MAR','APR','MAY','JUN','JUL','AUG','SEP','OCT','NOV','DEC'],
      accessibility: {
        rangeDescription: 'Range: Jan to Dec'
      }
    },

    legend: {
      layout: 'horizontal',
      align: 'center',
      verticalAlign: 'bottom'
    },
    credits:{
      enabled: false,
    },
    // plotOptions: {
    //   series: {
    //     label: {
    //       connectorAllowed: false
    //     },
    //     pointStart: 'Jan'
    //   }
    // },

    series: [{
      name: 'Insulin',
      color:'#ff779e',
      data: [
        43, 48, 65, 81, 112, 142,
        171, 165, 155, 161, 154, 168
      ]
    }, {
      name: 'Novomix',
      color:'#00acb1',
      data: [
        24, 37, 29, 29, 32, 30,
        38, 36, 33, 34, 31, 33
      ]
    }, {
      name: 'Mixtrad',
      color:'#002060',
      data: [
        11, 30, 16, 19, 20, 24,
        32, 30, 29, 29, 25, 28
      ]
    }, {
      name: 'ORS',
      data: [
        0, 0, 0, 0, 0, 0, 0,
        0, 11, 11, 10, 12
      ]
    }, {
      name: 'Syringe',
      data: [
        119, 155, 111, 112, 189, 118, 182,
        173, 130, 119, 100, 112
      ]
    }],

    responsive: {
      rules: [{
        condition: {
          maxWidth: 500
        },
        chartOptions: {
          legend: {
            layout: 'horizontal',
            align: 'center',
            verticalAlign: 'bottom'
          }
        }
      }]
    }

  };
  return <HighchartsReact
    highcharts={Highcharts}
    options={areaChart} />;
};

export default StockLineChart;